const safeWindow = () => /** @type {any} */ (window);

export const googleProvider = {
  name: 'google',

  isAvailable() {
    return Boolean(safeWindow().gtag);
  },

  track(eventName, payload = {}) {
    if (!this.isAvailable()) return;

    if (process.env.REACT_APP_ENV !== 'production') {
      console.log('[Tracking] Google track', eventName, payload);
      return;
    }

    safeWindow().gtag('event', eventName, payload);
  },
};
